<template>
	<div>
		<el-row style="margin: 15px 0;">
			<el-button type="text" size="small" @click='$router.back(-1)'>返回上一级</el-button>
		</el-row>
		<el-form label-width="120px" >
		  <el-form-item label="标题" class="form-line">
		    <el-input v-model="form.name" class="input-line"></el-input>
		  </el-form-item>
		  <el-form-item label="摘要" class="form-line">
		    <el-input v-model="form.desc" class="input-line"></el-input>
		  </el-form-item>
		  <el-form-item label="封面图" class="form-line">
			  <el-upload ref="upload" action="" :http-request="()=>{}"
			             :file-list="uploadImgList" list-type="picture"
			             :on-change="(file,fileList)=> { uploadImgList.push(file) }"
			             :on-remove="(file,fileList)=> { uploadImgList = fileList }">
			    <el-button slot="trigger" size="small" type="primary" v-if="!uploadImgList.length">选取文件</el-button>
			  </el-upload>
		  </el-form-item>
		  <el-form-item label="内容" class="form-line">
		  </el-form-item>
		  <div id="quill-container" style="min-height: 300px;"></div>
		</el-form>
		<el-button type="primary" style="margin-top: 20px;" @click="submit">确定</el-button>
		
		
		<input id="file" type="file" accept="image/png, image/gif, image/jpeg, image/bmp, image/x-icon" @change="onFileChange" />
	</div>
</template>

<script>
	import Quill from 'quill';
	import "quill/dist/quill.core.css"; // import styles
	import "quill/dist/quill.snow.css"; // for snow theme
	// import "quill/dist/quill.bubble.css"; 
	var toolbarOptions = [
	    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
	    ['blockquote', 'code-block'],
	    [{'list': 'ordered'}, {'list': 'bullet'}],
	    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
	    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
	    [{'direction': 'rtl'}],                         // text direction
	    [{'size': ['10px','12px',false,'16px','18px','20px','22px','24px','26px','32px','48px']}],  // custom dropdown
	    [{'header': [1, 2, 3, 4, 5, 6, false]}],
	    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
	    [{'font': []}],
	    [{'align': []}],
	    ['image'],
	    ['clean'],                                    // remove formatting button
	];
	let quillEditor = null
	export default {
		data() {
			return {
				form: {
					name: '',
					desc: '',
					pic_url: '',
					content: ''
				},
				uploadImgList: [],
				options: {
					height: '200px',
					modules: {
						toolbar: toolbarOptions,
						history: {
							delay: 2000,
							maxStack: 500,
							userOnly: true
						}
					},
					placeholder: '输入内容',
					readOnly: false,
					theme: 'snow'
				},
				id: ''
			}
		},
		methods: {
			getArticleDetail(id) {
				this.$axios.get('announcement/'+id).then(res => {
					if(!res.code){
						this.$message.error('获取详情失败')
						return 
					}
					let {name,desc,pic_url} = res.data
					document.querySelector('.ql-editor').innerHTML = res.data.content
					this.form.name = name
					this.form.desc = desc
					this.form.pic_url = pic_url
				});
			},
			initQuill() {
				quillEditor = new Quill('#quill-container', this.options);
				quillEditor.getModule('toolbar').addHandler("image", () => {
					document.getElementById("file").click();
				});
			},
			async submit() {
				if(this.uploadImgList.length) {
					this.form.pic_url = await this.uploadFile(this.uploadImgList[0].raw)
				}
				this.form.content = quillEditor.root.innerHTML
				let url = this.id ? 'announcement/'+this.id : 'announcement'
				let method = this.id ? 'put' : 'post'
				this.$axios[method](url, this.form).then(res => {
					if(!res.code){
						this.$message.error(res.message)
						return 
					}
					if(!this.id) {
						this.$router.replace({name: '资讯编辑',params: {id: res.data.id}})
						this.id = res.data.id
					}
					this.$message.success(res.message)
				}).catch((reason) =>{
					this.$message.error(reason)
				});
				// localStorage.setItem('quill-text',JSON.stringify(quillEditor.getContents().ops))
				localStorage.setItem('quill-content',quillEditor.root.innerHTML)
			},
			/** 上传文件 **/
			uploadFile(file) {
			  let form_data = new FormData();
			  form_data.append("file",file);
			  return this.$axios.post("uploads",form_data).then(res=> {
			    if (res.code) {
					if(typeof res.data == 'string') {
						return res.data
					}
					return res.data[0]
				}else { return '' };
			  })
			},
			onFileChange(event) {
				let tar = event.target;
				let files = tar.files;
				// if (files[0].size > 1024 * 1024 * 2) {
				// 	this.$message.error("图片大小不能超过2M");
				// 	return false;
				// }
	 
				let reader = new FileReader();
				reader.onload = async (e) => {
					let result = await this.uploadFile(e.target.result)
					//将图片插入需要获取当前光标的位置，参数为是否要求焦点在编辑器上
					let selection = quillEditor.getSelection(true);
					//调用insertEmbed 将图片插入到编辑器
					quillEditor.insertEmbed(selection.index, "image", result);
				};
				reader.readAsDataURL(files[0]);
			}
		},
		mounted() {
			this.id = this.$route.params.id
			this.initQuill();
			if(this.id) {
				this.getArticleDetail(this.id)
			}
		},
		components: {
			Quill
		}
	}
</script>

<style scoped>
	#file{
		display: none;
	}
</style>